


















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class SwiperNews extends Vue {
  @Prop()
  rightNew!: any;
  @Prop()
  leftNew!: any;
  @Prop()
  jump!: any;
  @Prop()
  zt!: any;

  url = "https://www.zj-huawei.com";
  showImg = true;
}
